import { useContext, useEffect } from 'react';
import useCustomHook from '@/hooks/useCustomHook';
import {
  parseSoundsData,
  parseClassicXMLSpriteSheets,
  parseImagesData,
  parseActivityData,
} from './parseConceptRaceAssetsData';
import { AudioAutoPlayerContext } from '@/shared/Players/AudioAutoPlayer/AudioAutoPlayerContext';

export default function useConceptRaceGame({
  gameAssetsFolder,
  commonAssetsFolder,
  activityData,
  onAnswer,
  onFinishedActivity,
  onStart,
  activityConf,
  language,
}) {
  const audioPlayerContext = useContext(AudioAutoPlayerContext);
  const { state, actions } = useCustomHook({
    defaultState: {
      screen: 'GAME',
      spritesData: null,
      spriteSheetImg: null,
    },
    actions: {
      prepareAssets: async () => {
        return {
          soundsData: parseSoundsData({
            gameData: activityData,
            gameAssetsFolder,
            commonAssetsFolder,
            activityConf,
            language,
          }),
          spritesData: await parseClassicXMLSpriteSheets(
            activityData,
            gameAssetsFolder,
            activityConf
          ),
          imagesData: parseImagesData(activityData, gameAssetsFolder),
        };
      },
      prepareGameData: () => {
        return parseActivityData(activityData, activityConf);
      },
      onFinish: () => {
        actions.setState({ screen: 'FINALFEEDBACK' });
        onFinishedActivity();
      },
    },
  });

  useEffect(() => {
    audioPlayerContext.actions.activate();
    return () => {
      audioPlayerContext.actions.reset();
    };
  }, [audioPlayerContext.state.player]);

  return { state, actions };
}
